import { Injectable } from '@angular/core';
import { cloneDeep } from 'lodash-es';

@Injectable()
export class StorageService {
  setItem(key: string, value: string): void {
    sessionStorage.setItem(key, value);
  }

  getItem(key: string, defaultVal: string = null): string {
    return sessionStorage.getItem(key) || defaultVal;
  }

  removeItem(key: string): void {
    sessionStorage.removeItem(key);
  }

  setObject(key: string, object: unknown): void {
    sessionStorage.setItem(key, JSON.stringify(object));
  }

  getObject(key: string, defaultVal: unknown = null): any {
    const object = sessionStorage.getItem(key);

    if (!object) {
      return cloneDeep(defaultVal);
    }

    return JSON.parse(object);
  }

  removeObject(key: string): void {
    this.removeItem(key);
  }
}
